module.exports = __webpack_public_path__ + "static/media/sacredheart.7c94c971.webp";